/**************************************************
 * Nombre:       Dialogo_Contenido_Caps
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {subirImagenHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Contenido_Caps from "../../Formularios/ContenidoCaps/Formulario_Contenido_Caps";
import {TIPOSCONTENIDO} from "../../../Constantes";
import {subirVideoHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirVideoHostingFile";
import {subirPdfHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirPdfHostingFile";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";

const Dialogo_Contenido_Caps = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')

        let contenidos = entidad.contenidos

        if (contenidos && contenidos.length > 0) {

            let cotes = []
            for (let contenido of contenidos) {

                switch (contenido.tipo) {
                    case TIPOSCONTENIDO[0]: //video
                        let dox = await subirVideoHostingFile(contenido.recurso)
                        contenido.recurso = dox.data
                        cotes.push(contenido)
                        break
                    case TIPOSCONTENIDO[1]: //pdf
                        let doxPdf = await subirPdfHostingFile(contenido.recurso)
                        contenido.recurso = doxPdf.data
                        cotes.push(contenido)
                        break
                    case TIPOSCONTENIDO[2]: //imagen
                        let doxIMg = await subirImagenHostingFile(contenido.recurso)
                        contenido.recurso = doxIMg.data
                        cotes.push(contenido)
                        break

                }

            }

        }

        let dox = await guardarDoc('contenidos', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('contenidos', datos.id)
        terminar({aviso: 'Contenido borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Contenido_Caps props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Contenido_Caps